<template>
  <div>
    <b-table
      head-variant="light"
      :fields="cabecalhoTabela"
      :items="planosParcelamento"
      :empty-text="$t('GERAL.NENHUM_REGISTRO')"
      responsive
      show-empty
      striped
      hover
    >
      <template #cell(inativar)="data">
        <b-button variant="danger" @click="inativarParcela(data.item)">
          Inativar
        </b-button>
      </template>
    </b-table>
    <div v-if="permiteInativarParcelas">
      <h5>Parcelas Inativadas</h5>
      <b-table
        head-variant="light"
        :fields="cabecalhoTabela"
        :items="inativados"
        :empty-text="$t('GERAL.NENHUM_REGISTRO')"
        responsive
        show-empty
        striped
        hover
      >
        <template #cell(inativar)="data">
          <b-button variant="primary" @click="ativarParcela(data.item)">
            Ativar
          </b-button>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import helpers from '@/common/utils/helpers';

export default {
  props: {
    form: { type: Object, default: Object },
    planosParcelamento: { type: Array, default: Array },
    permiteInativarParcelas: { type: Boolean, default: true },
  },
  data() {
    return {
      inativados: [],
    };
  },
  computed: {
    cabecalhoTabela() {
      const cabecalho = [
        {
          key: 'dataVencimento',
          sortable: true,
          label: this.$t('ACADEMICO.DATA_VENCIMENTO'),
        },
        {
          key: 'competencia',
          sortable: true,
          label: this.$t('ACADEMICO.COMPETENCIA'),
        },
        {
          key: 'valor',
          sortable: true,
          label: this.$t('ACADEMICO.VALOR'),
          formatter: (value) => {
            return value ? helpers.formatarReal(value) : '-';
          },
        },
        {
          key: 'parcela',
          sortable: true,
          label: this.$t('ACADEMICO.PARCELA'),
        },
        {
          key: 'descricao',
          label: this.$t('ACADEMICO.HISTORICO'),
        },
      ];

      return this.permiteInativarParcelas
        ? [...cabecalho, { key: 'inativar', label: '' }]
        : cabecalho;
    },
  },
  methods: {
    valid() {
      return true;
    },
    limparInativos() {
      this.inativados = [];
    },
    ativarParcela(item) {
      this.planosParcelamento.push(item);

      const index = this.inativados.indexOf(item);
      if (index > -1) this.inativados.splice(index, 1);
    },
    inativarParcela(item) {
      this.inativados.push(item);

      const index = this.planosParcelamento.indexOf(item);
      if (index > -1) this.planosParcelamento.splice(index, 1);
      this.$emit('remove', item);
    },
  },
};
</script>
